import { render, staticRenderFns } from "./DialogConsulta.vue?vue&type=template&id=4a5b583d&"
import script from "./DialogConsulta.vue?vue&type=script&lang=js&"
export * from "./DialogConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports